(function () {
  var COLOUR_MAP = {
    'obsidian': '#1a1a1a',
    'navy': '#1f2d3d',
    'true navy': '#1f2d3d',
    'sandstone': '#d4c4a8',
    'soft pink': '#e8c4c2',
    'khaki green': '#6e7355',
    'slate grey': '#7a7d82',
    'burgundy': '#5c1f28',
    'tan': '#b8825a'
  };

  function init() {
    var allFieldsets = Array.prototype.slice.call(document.querySelectorAll('variant-radios fieldset'));
    var colourFieldsets = allFieldsets.filter(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend) return false;
      return legend.textContent.trim().toLowerCase().indexOf('colour') !== -1;
    });

    if (!colourFieldsets.length) return;
    if (colourFieldsets[0].dataset.clanSwatchGroupInit === 'true') return;
    colourFieldsets.forEach(function (fieldset) {
      fieldset.dataset.clanSwatchGroupInit = 'true';
    });

    var isSingleSimpleCase = colourFieldsets.length === 1 &&
      colourFieldsets[0].querySelector('legend').textContent.trim().toLowerCase() === 'colour';

    // Bundle mode: two colour fieldsets, one per bag ("Greenwich Backpack
    // (Colour)" and "Camden Sling (Colour)"). Both option indexes are
    // tracked so the slider gallery can show the exact combination image.
    var isBundleMode = colourFieldsets.length === 2;
    var backpackOptionIndex = null;
    var slingOptionIndex = null;
    if (isBundleMode) {
      colourFieldsets.forEach(function (fieldset) {
        var optionIndex = allFieldsets.indexOf(fieldset);
        var legend = fieldset.querySelector('legend');
        var legendText = legend ? legend.textContent.toLowerCase() : '';
        if (legendText.indexOf('backpack') !== -1) {
          backpackOptionIndex = optionIndex;
        } else if (legendText.indexOf('sling') !== -1) {
          slingOptionIndex = optionIndex;
        }
      });
    }

    // Shared across ALL colour fieldsets on the page, so sold-out status
    // reflects the full selected combination, not each option in isolation.
    var variantScript = colourFieldsets[0].parentElement.querySelector('script[type="application/json"]');
    var variants = [];
    try {
      variants = variantScript ? JSON.parse(variantScript.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var selectedValues = [];
    var fieldsetMeta = [];

    colourFieldsets.forEach(function (fieldset) {
      var optionIndex = allFieldsets.indexOf(fieldset);
      var meta = setupSwatchFieldset(fieldset, isSingleSimpleCase, optionIndex);
      fieldsetMeta.push(meta);
    });

    // Run the bundle gallery filter once up front using the default
    // selection (first radio, or whichever is pre-checked).
    runBundleFilter();

    function runBundleFilter() {
      if (!isBundleMode || backpackOptionIndex === null) return;
      var backpackColour = selectedValues[backpackOptionIndex];
      if (!backpackColour) return;
      var slingColour = slingOptionIndex !== null ? selectedValues[slingOptionIndex] : undefined;

      if (document.querySelector('[data-clan-bundle-gallery]')) {
        // New slider gallery (sections/featured-product-bundle-gallery.liquid)
        filterBundleSliderGallery(backpackColour, slingColour);
      } else {
        // Fallback for any older markup without the data attributes
        filterBundleGalleryByBackpackColour(backpackColour);
      }
    }

    function setupSwatchFieldset(fieldset, singleMode, optionIndex) {
      var legend = fieldset.querySelector('legend');
      fieldset.classList.add('clan-swatch-fieldset');

      var legendColourSpan = null;

      if (singleMode && legend) {
        legend.style.position = 'absolute';
        legend.style.width = '1px';
        legend.style.height = '1px';
        legend.style.overflow = 'hidden';
        legend.style.clip = 'rect(0, 0, 0, 0)';
        legend.style.whiteSpace = 'nowrap';
        legend.style.border = '0';
        legend.style.padding = '0';
        legend.style.margin = '-1px';
      } else if (legend) {
        legend.style.fontSize = '1.3rem';
        legend.style.marginBottom = '0.6rem';
        legend.style.fontWeight = 'normal';

        var baseName = legend.textContent
          .replace(/\s*\(colour\)\s*$/i, '')
          .trim();

        legend.textContent = '';
        legend.appendChild(document.createTextNode(baseName + ' ('));
        legendColourSpan = document.createElement('span');
        legendColourSpan.className = 'clan-native-selected-colour';
        legend.appendChild(legendColourSpan);
        legend.appendChild(document.createTextNode(')'));
      }

      var selectedLabel = null;
      if (singleMode) {
        selectedLabel = document.createElement('p');
        selectedLabel.className = 'clan-swatch-selected-label';
        fieldset.insertBefore(selectedLabel, fieldset.firstChild.nextSibling);
      }

      var row = document.createElement('div');
      row.classList.add('clan-swatch-row');

      var inputs = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
      inputs.forEach(function (input) {
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        var colourValue = input.value;
        var colourKey = colourValue.trim().toLowerCase();
        var hex = COLOUR_MAP[colourKey] || '#d9d9d9';

        input.classList.add('clan-swatch-input');
        label.classList.add('clan-swatch');
        label.style.setProperty('--clan-swatch-colour', hex);
        label.setAttribute('title', colourValue);

        var wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        wrapper.style.display = 'inline-flex';
        input.parentNode.insertBefore(wrapper, input);
        wrapper.appendChild(input);
        wrapper.appendChild(label);
        row.appendChild(wrapper);

        if (input.checked) {
          selectedValues[optionIndex] = colourValue;
        }

        input.addEventListener('change', function () {
          selectedValues[optionIndex] = colourValue;
          if (legendColourSpan) legendColourSpan.textContent = colourValue;
          if (singleMode) {
            updateSelectedLabel(selectedLabel, colourValue);
            filterGalleryByColour(colourValue);
          }
          runBundleFilter();
          refreshAllSoldOutStates();
        });
      });

      fieldset.appendChild(row);

      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var initialColour = checked ? checked.value : (inputs[0] ? inputs[0].value : null);
      if (initialColour) {
        if (legendColourSpan) legendColourSpan.textContent = initialColour;
        if (singleMode) {
          updateSelectedLabel(selectedLabel, initialColour);
          filterGalleryByColour(initialColour);
        }
      }

      return { fieldset: fieldset, inputs: inputs, optionIndex: optionIndex };
    }

    // Does this value have at least one available variant anywhere it's used,
    // regardless of what the other option is set to? If not, it's "dead" and
    // shouldn't be used to constrain sold-out checks on other option rows.
    function isValueDeadEverywhere(optionIndex, value) {
      var anyAvailable = variants.some(function (variant) {
        var opts = variant.options || [];
        return opts[optionIndex] === value && variant.available !== false;
      });
      return !anyAvailable;
    }

    // True only if at least one variant matches the (possibly wildcarded)
    // values, and every variant that matches is unavailable. A value of
    // undefined at a given position means "any value accepted there".
    function isCombinationUnavailable(values) {
      var anyMatch = false;
      var anyMatchAvailable = false;

      variants.forEach(function (variant) {
        var opts = variant.options || [];
        var matches = values.every(function (val, i) {
          return val === undefined || opts[i] === val;
        });
        if (!matches) return;
        anyMatch = true;
        if (variant.available !== false) anyMatchAvailable = true;
      });

      return anyMatch && !anyMatchAvailable;
    }

    function refreshAllSoldOutStates() {
      fieldsetMeta.forEach(function (meta) {
        // Build the constraint from every OTHER fieldset's current selection,
        // but drop any selection that's dead everywhere so it can't cascade
        // unavailability onto swatches in this row.
        var constrainedValues = [];
        selectedValues.forEach(function (val, i) {
          if (i === meta.optionIndex || val === undefined) return;
          constrainedValues[i] = isValueDeadEverywhere(i, val) ? undefined : val;
        });

        meta.inputs.forEach(function (input) {
          var label = meta.fieldset.querySelector('label[for="' + input.id + '"]');
          if (!label) return;

          var testValues = constrainedValues.slice();
          testValues[meta.optionIndex] = input.value;

          if (isCombinationUnavailable(testValues)) {
            label.classList.add('is-soldout');
            label.setAttribute('title', input.value + ' - sold out');
          } else {
            label.classList.remove('is-soldout');
            label.setAttribute('title', input.value);
          }
        });
      });
    }

    refreshAllSoldOutStates();
  }

  function updateSelectedLabel(selectedLabel, colourValue) {
    if (selectedLabel) {
      selectedLabel.textContent = 'Colour: ' + colourValue;
    }
  }

  function filterGalleryByColour(colourValue) {
    var needle = ('- ' + colourValue).trim().toLowerCase();

    var mediaItems = document.querySelectorAll('.product__media-item');
    var thumbItems = document.querySelectorAll('.thumbnail-list__item');

    var anyMatch = false;
    mediaItems.forEach(function (item) {
      var img = item.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      if (alt.toLowerCase().indexOf(needle) !== -1) anyMatch = true;
    });

    if (!anyMatch) return;

    mediaItems.forEach(function (item) {
      var img = item.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      var matches = alt.toLowerCase().indexOf(needle) !== -1;
      item.style.display = matches ? '' : 'none';
    });

    thumbItems.forEach(function (item) {
      var img = item.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      var matches = alt.toLowerCase().indexOf(needle) !== -1;
      item.style.display = matches ? '' : 'none';
    });
  }

  function normaliseColour(value) {
    return (value || '').trim().toLowerCase();
  }

  // Recalculate the Dawn slider after slides are shown/hidden, so the
  // counter reflects visible slides only (hidden slides have clientWidth 0
  // and are excluded by slider-component), and snap back to the first slide.
  function resetBundleSlider(gallery) {
    var slider = gallery.querySelector('slider-component');
    if (!slider) return;
    window.requestAnimationFrame(function () {
      if (typeof slider.resetPages === 'function') {
        slider.resetPages();
      } else if (typeof slider.initPages === 'function') {
        slider.initPages();
      }
      var list = slider.querySelector('[id^="Slider-"]');
      if (list && typeof list.scrollTo === 'function') list.scrollTo({ left: 0 });
    });
  }

  // Slider gallery filter (data-attribute driven, no alt parsing for combos):
  //   combo   -> only the slide matching BOTH selected colours is visible
  //   detail  -> backpack shots follow the backpack colour; sling shots
  //              follow the backpack colour by default, or the sling colour
  //              if the section's "sling_details_follow" setting is "sling"
  //   general -> never touched, always visible
  function filterBundleSliderGallery(backpackColour, slingColour) {
    var backpackKey = normaliseColour(backpackColour);
    var slingKey = normaliseColour(slingColour);

    document.querySelectorAll('[data-clan-bundle-gallery]').forEach(function (gallery) {
      var followSling = gallery.getAttribute('data-sling-details-follow') === 'sling';

      var combos = Array.prototype.slice.call(gallery.querySelectorAll('[data-clan-role="combo"]'));
      var matchedCombo = null;
      combos.forEach(function (item) {
        if (matchedCombo) return;
        var backpackMatch = normaliseColour(item.getAttribute('data-backpack-colour')) === backpackKey;
        var slingMatch = !slingKey || normaliseColour(item.getAttribute('data-sling-colour')) === slingKey;
        if (backpackMatch && slingMatch) matchedCombo = item;
      });
      // If a combination has no image, keep whatever Dawn marked active
      // rather than leaving the gallery without a hero.
      if (!matchedCombo) matchedCombo = gallery.querySelector('[data-clan-role="combo"].is-active');

      combos.forEach(function (item) {
        item.style.display = item === matchedCombo ? '' : 'none';
      });
      if (matchedCombo && matchedCombo.parentElement) {
        matchedCombo.parentElement.prepend(matchedCombo);
      }

      gallery.querySelectorAll('[data-clan-role="detail"]').forEach(function (item) {
        var type = item.getAttribute('data-clan-type');
        var target = (type === 'sling' && followSling) ? slingKey : backpackKey;
        item.style.display = normaliseColour(item.getAttribute('data-clan-colour')) === target ? '' : 'none';
      });

      resetBundleSlider(gallery);
    });
  }

  // Legacy bundle gallery filter, kept as a fallback for markup without the
  // [data-clan-bundle-gallery] slider. Shows only the standalone
  // "Greenwich Backpack - {Colour}" and "Camden Sling - {Colour}" shots that
  // match the selected Backpack colour, and filters the old
  // .clan-bundle-gallery__item grid by data-colour.
  function filterBundleGalleryByBackpackColour(backpackColour) {
    var needleBackpack = ('greenwich backpack - ' + backpackColour).trim().toLowerCase();
    var needleSling = ('camden sling - ' + backpackColour).trim().toLowerCase();

    function matchesSelection(alt) {
      var a = (alt || '').trim().toLowerCase();
      return a === needleBackpack || a === needleSling;
    }

    var mediaItems = document.querySelectorAll('.product__media-item');
    var thumbItems = document.querySelectorAll('.thumbnail-list__item');
    var galleryGridItems = document.querySelectorAll('.clan-bundle-gallery__item');

    if (galleryGridItems.length) {
      var needleColour = backpackColour.trim().toLowerCase();
      galleryGridItems.forEach(function (item) {
        var itemColour = (item.getAttribute('data-colour') || '').trim().toLowerCase();
        item.style.display = (itemColour === needleColour) ? '' : 'none';
      });
    }

    var anyStandaloneMatch = false;
    mediaItems.forEach(function (item) {
      var img = item.querySelector('img');
      var alt = img ? img.getAttribute('alt') : '';
      if (matchesSelection(alt)) anyStandaloneMatch = true;
    });

    if (!anyStandaloneMatch) return;

    function applyVisibility(item) {
      var img = item.querySelector('img');
      var alt = img ? img.getAttribute('alt') : '';
      if (!alt) return;
      item.style.display = matchesSelection(alt) ? '' : 'none';
    }

    mediaItems.forEach(applyVisibility);
    thumbItems.forEach(applyVisibility);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();